export function stripHtmlTags(html: string): any {
  return html
    .replace(/&nbsp;/g, ' ') // Replace &nbsp; with regular space
    .replace(/&amp;/g, '&') // Replace &amp; with &
    .replace(/&lt;/g, '<') // Replace &lt; with <
    .replace(/&gt;/g, '>') // Replace &gt; with >
    .replace(/(<([^>]+)>)/gi, ''); // Remove HTML tags
}

export default function sortFctReactTable(rowA, rowB, columnId) {
  const val1 = rowA.getValue(columnId);
  const val2 = rowB.getValue(columnId);
  if (!val1 || !val2) {
    return true;
  }
  if (typeof val1 !== 'string' || typeof val2 !== 'string') {
    return true;
  }
  return stripHtmlTags(val1).localeCompare(stripHtmlTags(val2));
}
